import { axiosRequest } from "../axios.config";

const audioLanguageApi = {
  getAllAudioLanguage: async () => {
    const url = "AudioLanguage";
    const response = await axiosRequest.get(url);
    return response;
  },
};

export { audioLanguageApi };
